import { createVapor } from '@frameio/vapor';

// instantiate a memoized React Provider component
export const { VaporProvider } = createVapor();
